/*
  The home page (round 40): what moves on sections/vr-home-*.liquid. Loaded by each of them, run once.
  One scroll engine reads the page's position once a frame and eases every scene toward it (so the motion stays
  smooth however the wheel or the finger moves):
  - the entrance: a canvas draws the night with the house's name cut out of it; the gold in the letters melts away
    to show the Raina film behind, the name opens until the film fills the screen, the night lifts and the house's
    line rises;
  - the collections: on wide screens the chapters travel sideways while the page is scrolled, each portrait drifting
    within its arch, each drawn name taking one band of light as it reaches the middle;
  - the karkhana: its film opens from an arch to the whole screen.
  Elsewhere: films load after the page and play only on screen (never for visitors who save data); drawn names and
  mastheads are cropped to their ink; the shelf of pieces scrolls by its arrows and shows where it is; things rise
  into place as they come into view; the wax seal is pressed; the film with sound plays over the page.
  Visitors who ask for reduced motion see every scene still and whole (the styles' still layout).
*/
(function () {
  if (window.__vrHome) return;
  window.__vrHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  /* round 45: a slow connection (3G or less, or data saver) keeps the still; the film would take half a minute */
  var saving = conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
  var hasIO = 'IntersectionObserver' in window;
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var span = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };
  var easeIn = function (t) { return t * t * t; };
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };
  var easeInOut = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  /* ---- the header the stages sit under ---- */
  function headerTop() {
    var h = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if (!h) return 0;
    /* a header that shows only while scrolling up leaves the top of the screen to the scenes */
    var type = h.getAttribute('data-sticky-type');
    if (type && type !== 'always' && type !== 'reduce-logo-size') return 0;
    var host = h.closest('.shopify-section') || h;
    var pos = window.getComputedStyle(host).position;
    if (pos !== 'sticky' && pos !== 'fixed' && window.getComputedStyle(h).position !== 'sticky') return 0;
    return Math.round(h.getBoundingClientRect().height);
  }

  /* ---- the scroll engine: each scene has a target from the scroll position and an eased value ---- */
  var scenes = [];
  var running = false, last = 0;
  function measureAll() {
    var top = headerTop();
    document.querySelectorAll('.vrh').forEach(function (el) { el.style.setProperty('--vrh-top', top + 'px'); });
    scenes.forEach(function (s) { s.measure(); });
    tick();
  }
  function tick() {
    var y = window.scrollY || window.pageYOffset;
    scenes.forEach(function (s) { s.target = s.read(y); if (s.cur === null) s.cur = s.target; });
    if (!running) { running = true; last = 0; window.requestAnimationFrame(loop); }
  }
  function loop(now) {
    var dt = last ? Math.min(64, now - last) : 16.7;
    last = now;
    var k = 1 - Math.pow(1 - 0.12, dt / 16.7);
    var busy = false;
    scenes.forEach(function (s) {
      var d = s.target - s.cur;
      if (Math.abs(d) > s.eps) { s.cur += d * k; busy = true; } else s.cur = s.target;
      if (s.cur !== s.drawn) { s.render(s.cur); s.drawn = s.cur; }
    });
    if (busy) window.requestAnimationFrame(loop); else running = false;
  }
  function scene(o) { o.cur = null; o.drawn = null; o.target = 0; o.eps = o.eps || 0.0004; scenes.push(o); return o; }

  /* ---- films that play silently once the page has loaded, while on screen ---- */
  function film(v, box, mobileFirst) {
    if (!v || reduce || saving) return;
    var src = (mobileFirst && window.matchMedia('(max-width: 749.98px)').matches && v.getAttribute('data-src-mobile')) || v.getAttribute('data-src');
    if (!src) return;
    var started = false, onScreen = false, pageReady = document.readyState === 'complete';
    var play = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    var start = function () {
      if (started || !pageReady || !onScreen) return;
      started = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      v.src = src;
      /* a film that ends on a title card loops just before it */
      var trim = parseFloat(v.getAttribute('data-trim-end') || '0');
      if (trim > 0) v.addEventListener('timeupdate', function () { if (v.duration && v.currentTime > v.duration - trim) v.currentTime = 0.05; });
      play();
    };
    /* round 45: the fallback for a load that never comes is 6 s, not 2.5 s, so on a slow phone the film no longer
       competes with the page's own photographs */
    if (!pageReady) window.addEventListener('load', function () { pageReady = true; window.setTimeout(start, 250); }, { once: true });
    window.setTimeout(function () { pageReady = true; start(); }, 6000);
    if (hasIO) new IntersectionObserver(function (es) {
      onScreen = es[0].isIntersecting;
      if (!started) { start(); return; }
      if (onScreen) play(); else v.pause();
    }, { threshold: 0.02 }).observe(box || v);
    else { onScreen = true; start(); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && started && onScreen) play(); });
  }

  /* ---- drawn names and mastheads, cropped to their ink ---- */
  var inks = {};
  function ink(url, done) {
    var c = inks[url];
    if (c) { if (c.ready) done(c.v); else c.q.push(done); return; }
    c = inks[url] = { ready: false, v: null, q: [done] };
    var finish = function (v) { c.ready = true; c.v = v; c.q.forEach(function (f) { f(v); }); c.q = []; };
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = 320, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var g = cv.getContext('2d'); g.drawImage(im, 0, 0, W, H);
        var d = g.getImageData(0, 0, W, H).data;
        var x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) { if (d[(y * W + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
        if (x1 < 0) { finish(null); return; }
        var fw = (x1 + 1 - x0) / W, fh = (y1 + 1 - y0) / H, fx = x0 / W, fy = y0 / H;
        finish({ ar: (fw * im.naturalWidth) / (fh * im.naturalHeight), size: (100 / fw).toFixed(2) + '% ' + (100 / fh).toFixed(2) + '%', pos: (fw >= 0.999 ? 50 : fx / (1 - fw) * 100).toFixed(2) + '% ' + (fh >= 0.999 ? 50 : fy / (1 - fh) * 100).toFixed(2) + '%' });
      } catch (e) { finish(null); }
    };
    im.onerror = function () { finish(null); };
    im.src = url;
  }
  function marks(root) {
    root.querySelectorAll('[data-vrh-ink]').forEach(function (el) {
      if (el.dataset.vrhInked) return;
      el.dataset.vrhInked = '1';
      ink(el.getAttribute('data-vrh-ink'), function (v) {
        if (!v) return;
        el.style.setProperty('--ink-ar', v.ar.toFixed(4));
        el.style.setProperty('--ink-size', v.size);
        el.style.setProperty('--ink-pos', v.pos);
        el.style.setProperty('--ink-boost', Math.min(1.42, Math.max(0.74, Math.sqrt((el.classList.contains('vrh-mast') ? 3 : 2.6) / v.ar))).toFixed(3));
        el.classList.add('is-measured');
        if (el.classList.contains('vrh-mast')) pace();
      });
    });
  }
  var paceTimer = 0;
  function pace() {
    window.clearTimeout(paceTimer);
    paceTimer = window.setTimeout(function () {
      document.querySelectorAll('[data-vrh-track]').forEach(function (t) { var w = t.scrollWidth / 2; if (w > 0) t.style.setProperty('--drift', Math.max(50, w / 30).toFixed(1) + 's'); });
    }, 150);
  }

  /* ---- I. the entrance ---- */
  function hero(sec) {
    var stage = sec.querySelector('.vrh-hero__stage');
    var canvas = sec.querySelector('[data-vrh-canvas]');
    var logoEl = sec.querySelector('.vrh-hero__logo');
    var media = sec.querySelector('.vrh-hero__media');
    var words = sec.querySelector('.vrh-hero__words');
    var shade = sec.querySelector('.vrh-hero__shade');
    var nightLayer = sec.querySelector('.vrh-hero__night');
    var v = sec.querySelector('[data-vrh-film]');
    film(v, sec, true);
    if (reduce || !canvas || !canvas.getContext) return;
    var src = sec.getAttribute('data-logo');
    var logo = new Image();
    logo.crossOrigin = 'anonymous';
    logo.onload = function () {
      var ok = true;
      /* the name in the house's gold, drawn once at full size */
      var gold = document.createElement('canvas');
      gold.width = logo.naturalWidth; gold.height = logo.naturalHeight;
      try {
        var gg = gold.getContext('2d');
        gg.drawImage(logo, 0, 0);
        gg.globalCompositeOperation = 'source-in';
        var grd = gg.createLinearGradient(0, 0, gold.width * 0.14, gold.height);
        grd.addColorStop(0, '#f6e6ad'); grd.addColorStop(0.34, '#dcb95c'); grd.addColorStop(0.64, '#b38d31'); grd.addColorStop(1, '#e8cb7c');
        gg.fillStyle = grd; gg.fillRect(0, 0, gold.width, gold.height);
      } catch (e) { ok = false; }
      if (!ok) return;
      sec.classList.add('is-live');
      var ctx = canvas.getContext('2d');
      var W = 0, H = 0, dpr = 1, box = null, top = 0, range = 1, origin = [0.585, 0.19];
      var o = scene({
        measure: function () {
          var r = stage.getBoundingClientRect();
          W = r.width; H = r.height;
          dpr = Math.min(window.devicePixelRatio || 1, 2);
          canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
          var lr = logoEl.getBoundingClientRect();
          box = { x: lr.left - r.left, y: lr.top - r.top, w: lr.width, h: lr.height };
          var sr = sec.getBoundingClientRect();
          top = sr.top + (window.scrollY || window.pageYOffset);
          range = Math.max(1, sec.offsetHeight - H);
          o.drawn = null;
        },
        read: function (y) { return clamp((y - top) / range, 0, 1); },
        render: function (p) {
          var zoom = easeIn(span(p, 0.05, 0.62));
          var s = 1 + 34 * zoom;
          var night = 1 - span(p, 0.5, 0.64);
          var goldA = 1 - span(p, 0.01, 0.15);
          canvas.style.opacity = night.toFixed(3);
          if (night > 0 && box) {
            var ox = box.x + box.w * origin[0], oy = box.y + box.h * origin[1];
            var x = ox + (box.x - ox) * s, y = oy + (box.y - oy) * s, w = box.w * s, h = box.h * s;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            ctx.globalCompositeOperation = 'source-over';
            ctx.globalAlpha = 1;
            ctx.clearRect(0, 0, W, H);
            ctx.fillStyle = '#14100b';
            ctx.fillRect(0, 0, W, H);
            ctx.globalCompositeOperation = 'destination-out';
            ctx.drawImage(logo, x, y, w, h);
            ctx.globalCompositeOperation = 'source-over';
            if (goldA > 0.002) { ctx.globalAlpha = goldA; ctx.drawImage(gold, x, y, w, h); ctx.globalAlpha = 1; }
          }
          var lead = 1 - span(p, 0, 0.08);
          nightLayer.style.opacity = lead.toFixed(3);
          if (p > 0.002) handOver();
          var wv = easeOut(span(p, 0.62, 0.84));
          words.style.opacity = wv.toFixed(3);
          words.style.transform = 'translate3d(0,' + ((1 - wv) * 30).toFixed(1) + 'px,0)';
          shade.style.opacity = span(p, 0.5, 0.75).toFixed(3);
          media.style.transform = 'scale(' + (1.12 - 0.12 * easeOut(span(p, 0.05, 0.7))).toFixed(4) + ')';
        }
      });
      /* the drawn name (with its band of light) stays over the canvas until the visitor scrolls or the light has
         crossed; the two are drawn alike, so the change is not seen */
      var handed = false;
      function handOver() { if (handed) return; handed = true; sec.classList.add('is-drawn'); }
      o.measure();
      o.render(o.read(window.scrollY || window.pageYOffset));
      window.setTimeout(handOver, 4800);
      tick();
    };
    logo.onerror = function () {};
    logo.src = src;
  }

  /* ---- II. the collections ---- */
  function chapters(sec) {
    var track = sec.querySelector('[data-vrh-track-chapters]');
    var items = Array.prototype.slice.call(sec.querySelectorAll('[data-vrh-chapter]'));
    var dots = Array.prototype.slice.call(sec.querySelectorAll('.vrh-chapters__dot'));
    if (!track || !items.length) return;
    var setDot = function (i) { dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); };
    var light = function (el) { if (!el.classList.contains('is-lit')) el.classList.add('is-lit'); };
    var wide = window.matchMedia('(min-width: 990px)');
    if (reduce || !wide.matches) {
      /* swiped: the dots follow the chapter in the middle; each name takes its light once it is seen */
      var onSwipe = function () {
        var mid = window.innerWidth / 2, best = 0, bd = Infinity;
        items.forEach(function (el, i) { var r = el.getBoundingClientRect(); var d = Math.abs(r.left + r.width / 2 - mid); if (d < bd) { bd = d; best = i; } });
        setDot(best);
        if (!reduce) light(items[best]);
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(onSwipe); }, { passive: true });
      if (hasIO) new IntersectionObserver(function (es) { if (es[0].isIntersecting) onSwipe(); }, { threshold: 0.4 }).observe(track);
      onSwipe();
      /* round 50: a dot brings its chapter to the middle of the row */
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          var r = items[i].getBoundingClientRect(), t = track.getBoundingClientRect();
          track.scrollBy({ left: (r.left + r.width / 2) - (t.left + t.width / 2), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      return;
    }
    sec.classList.add('is-live');
    var top = 0, range = 1, max = 0, vw = 0, H = 0, curX = 0;
    var stage = sec.querySelector('.vrh-chapters__stage');
    var arches = items.map(function (el) { return el.querySelector('.vrh-chapter__arch img'); });
    var o = scene({
      eps: 0.3,
      measure: function () {
        sec.style.height = '';
        H = stage.getBoundingClientRect().height;
        vw = window.innerWidth;
        track.style.transform = 'translate3d(0,0,0)';
        max = Math.max(0, track.scrollWidth - vw);
        sec.style.height = Math.round(H + max) + 'px';
        var sr = sec.getBoundingClientRect();
        top = sr.top + (window.scrollY || window.pageYOffset);
        range = Math.max(1, sec.offsetHeight - H);
        o.drawn = null;
      },
      read: function (y) { return clamp((y - top) / range, 0, 1) * max; },
      render: function (x) {
        curX = x;
        track.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
        var mid = vw / 2, best = -1, bd = Infinity;
        items.forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          var c = r.left + r.width / 2;
          var rel = clamp((c - mid) / vw, -1.2, 1.2);
          if (arches[i]) arches[i].style.setProperty('--par', (rel * -7).toFixed(2) + '%');
          var d = Math.abs(c - mid);
          if (d < bd) { bd = d; best = i; }
          if (Math.abs(rel) < 0.18) light(el);
        });
        setDot(best);
      }
    });
    o.measure();
    /* round 50: a dot scrolls the page to where its chapter stands in the middle of the screen (the chapters travel
       sideways as the page is scrolled) */
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        /* the travel that brings it to the middle: where the row stands now, plus how far its middle is from the screen's */
        var r = items[i].getBoundingClientRect();
        var x = clamp(curX + (r.left + r.width / 2 - vw / 2), 0, max);
        window.scrollTo({ top: top + (max ? x / max : 0) * range, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---- V. the karkhana ---- */
  function karkhana(sec) {
    var stage = sec.querySelector('.vrh-karkhana__stage');
    var win = sec.querySelector('.vrh-karkhana__window');
    var v = sec.querySelector('[data-vrh-film]');
    film(v, sec, false);
    if (reduce || !window.matchMedia('(min-width: 750px)').matches) return;
    sec.classList.add('is-live');
    var top = 0, range = 1, W = 0, H = 0;
    var o = scene({
      measure: function () {
        var r = stage.getBoundingClientRect();
        W = r.width; H = r.height;
        var sr = sec.getBoundingClientRect();
        top = sr.top + (window.scrollY || window.pageYOffset);
        range = Math.max(1, sec.offsetHeight - H);
        o.drawn = null;
      },
      read: function (y) { return clamp((y - top) / range, 0, 1); },
      render: function (p) {
        var e = easeInOut(span(p, 0.06, 0.62));
        var w0 = Math.min(W * 0.46, H * 0.62 * 1.1), h0 = H * 0.72;
        var sx = (W - w0) / 2 * (1 - e), ty = (H - h0) / 2 * (1 - e);
        var r = (w0 / 2) * (1 - e) + 0;
        win.style.setProperty('--s', sx.toFixed(1) + 'px');
        win.style.setProperty('--t', ty.toFixed(1) + 'px');
        win.style.setProperty('--b', ty.toFixed(1) + 'px');
        win.style.setProperty('--r', r.toFixed(1) + 'px');
        win.style.setProperty('--rb', (14 * (1 - e)).toFixed(1) + 'px');
        sec.style.setProperty('--shade', span(p, 0.5, 0.8).toFixed(3));
        sec.style.setProperty('--words', easeOut(span(p, 0.6, 0.86)).toFixed(3));
      }
    });
    o.measure();
  }

  /* ---- III. the shelf ---- */
  function shelf(sec) {
    var track = sec.querySelector('[data-vrh-shelf]');
    var prev = sec.querySelector('.vrh-shelf__btn--prev'), next = sec.querySelector('.vrh-shelf__btn--next');
    var bar = sec.querySelector('.vrh-shelf__progress span');
    if (!track) return;
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      var share = track.clientWidth / Math.max(1, track.scrollWidth);
      if (bar) { bar.style.setProperty('--w', (share * 100).toFixed(2) + '%'); bar.style.setProperty('--x', (max > 0 ? track.scrollLeft / max * (1 / share - 1) * 100 : 0).toFixed(2) + '%'); }
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    };
    var by = function (dir) {
      var card = track.querySelector('.vrh-card');
      var step = card ? card.getBoundingClientRect().width + parseFloat(window.getComputedStyle(track).columnGap || 24) : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * step * Math.max(1, Math.floor(track.clientWidth / step) - 1), behavior: reduce ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- things rise into place; the seal is pressed ---- */
  function reveal(root) {
    if (reduce || !hasIO) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });
    var topY = null, d = 0;
    root.querySelectorAll('[data-vrh-reveal]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) return;
      if (topY === null || Math.abs(r.top - topY) > 40) { topY = r.top; d = 0; } else d++;
      el.style.setProperty('--d', Math.min(d, 5));
      el.classList.add('is-armed');
      io.observe(el);
    });
    root.querySelectorAll('[data-vrh-seal]').forEach(function (el) {
      el.classList.add('is-armed');
      var so = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { so.disconnect(); window.requestAnimationFrame(function () { el.classList.add('is-pressed'); }); } });
      }, { threshold: 0.6 });
      so.observe(el);
    });
  }

  /* ---- the film with sound ---- */
  function watch() {
    var modal = document.querySelector('[data-vrh-film-modal]');
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-vrh-watch]'));
    if (!modal || !buttons.length) return;
    document.body.appendChild(modal);
    var frame = modal.querySelector('.vrh-film-modal__frame'), title = modal.querySelector('.vrh-film-modal__title'), close = modal.querySelector('[data-vrh-film-close]');
    var from = null, timer = 0;
    var open = function (b) {
      var id = b.getAttribute('data-vrh-watch');
      if (!id) return;
      window.clearTimeout(timer);
      from = b;
      title.textContent = b.getAttribute('data-vrh-watch-title') || '';
      while (frame.firstChild) frame.removeChild(frame.firstChild);
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = title.textContent || 'Film';
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      frame.appendChild(f);
      modal.hidden = false;
      document.documentElement.classList.add('vrh-film-open');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { modal.classList.add('is-open'); }); });
      close.focus();
    };
    var shut = function () {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('vrh-film-open');
      while (frame.firstChild) frame.removeChild(frame.firstChild);
      timer = window.setTimeout(function () { modal.hidden = true; }, reduce ? 0 : 500);
      if (from) from.focus();
    };
    buttons.forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
    close.addEventListener('click', shut);
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('vrh-film-modal__inner')) shut(); });
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && !modal.hidden) shut(); });
    document.addEventListener('focusin', function (e) { if (!modal.hidden && modal.classList.contains('is-open') && !modal.contains(e.target)) close.focus(); });
  }

  /* ---- smooth travel to the collections ---- */
  function anchors() {
    document.querySelectorAll('.vrh a[href^="#vrh-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - headerTop();
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function init() {
    measureTop();
    document.querySelectorAll('[data-vrh-hero]').forEach(hero);
    document.querySelectorAll('[data-vrh-chapters]').forEach(chapters);
    document.querySelectorAll('[data-vrh-karkhana]').forEach(karkhana);
    document.querySelectorAll('[data-vrh-shelf-section]').forEach(shelf);
    reveal(document);
    watch();
    anchors();
    pace();
    if ('requestIdleCallback' in window) window.requestIdleCallback(function () { marks(document); }, { timeout: 1200 }); else window.setTimeout(function () { marks(document); }, 300);
    window.addEventListener('scroll', tick, { passive: true });
    var rt = 0;
    window.addEventListener('resize', function () { window.clearTimeout(rt); rt = window.setTimeout(measureAll, 160); });
    window.addEventListener('load', measureAll);
    if (window.ResizeObserver) { try { var ro = new ResizeObserver(function () { window.clearTimeout(rt); rt = window.setTimeout(measureAll, 160); }); ro.observe(document.body); } catch (e) {} }
    measureAll();
  }
  function measureTop() { var top = headerTop(); document.querySelectorAll('.vrh').forEach(function (el) { el.style.setProperty('--vrh-top', top + 'px'); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
